import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';

@Component({
    selector: 'website-builder-filter',
    templateUrl: './website-builder-filter.component.html',
    styleUrls: ['./website-builder-filter.component.scss']
})
export class WebsiteBuilderFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('publishedCheckbox') published: ElementRef;

    constructor(
        private urlService: UrlService
    ) {}

    ngOnInit() {
        const status = this.urlService.queryParams['status'];

        this.urlService.onUrlChange.subscribe(_ => {
            if (!_.status) {
                this.published.nativeElement.checked = false;
            }
        });
        if (status) {
            this.published.nativeElement.checked = status.indexOf('availableCheckbox') !== -1;
        }
    }

    changeFilter() {
        const availableValue = this.published.nativeElement.checked;

        if (!availableValue)
            this.urlService.queryParams['status'] = null;
        else
            this.urlService.queryParams['status'] = 'true';

        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('website-builder-filter')) this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/website-builder-filter/website-builder-filter.component.ts